<template>
    <div class="agreement">
        <span @click="goAgreement1">《会员服务协议》</span><i>|</i>
        <span @click="goAgreement2">《自动续费协议》</span>
    </div>
</template>

<script>
export default {
    props: {
        source: {   // and；ios
            type: String
        }      
    },
    methods: {
        goAgreement1() {
            let url = window.location.href.split('?')[0];
            let path = this.source === 'ios' ? url.split("member_ios").join('member_service_agreement') : url.split("member_and").join('member_service_agreement');
            url = encodeURIComponent(path);
            window.location.href = "hybird://method/openNewWindow?url=" + url + "&title=小盒家长会员服务协议";
        },
        goAgreement2() {
            let url = window.location.href.split('?')[0];
            let path = this.source === 'ios' ? url.split("member_ios").join('member_xufei') : url.split("member_and").join('member_xufei');
        
                url = encodeURIComponent(path + '?hideTitleBar=false')
                window.location.href = "hybird://method/openNewWindow?url=" + url + "&title=自动续费协议";;
        }
    }
}
</script>

<style lang="scss" scoped>
    .agreement {
        background: #ffffff;
        // width: 4.02rem;
        padding: .6rem 1.7rem .46rem 1.7rem;
        display: flex;
        justify-content: space-between;
        font-size: .22rem;
        color: #43a5f3;
        i {
            color: #dfe4ee;
        }
    }
</style>